import { render, staticRenderFns } from "./StartNode.vue?vue&type=template&id=599ee5a5&scoped=true"
import script from "./StartNode.vue?vue&type=script&lang=js"
export * from "./StartNode.vue?vue&type=script&lang=js"
import style0 from "./StartNode.vue?vue&type=style&index=0&id=599ee5a5&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "599ee5a5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\G\\YT\\mes-project-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('599ee5a5')) {
      api.createRecord('599ee5a5', component.options)
    } else {
      api.reload('599ee5a5', component.options)
    }
    module.hot.accept("./StartNode.vue?vue&type=template&id=599ee5a5&scoped=true", function () {
      api.rerender('599ee5a5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SimpleFlow/src/components/StartNode.vue"
export default component.exports